import React from 'react';
import {BackgroundImageProps} from 'app/utilities/ImageProps';
import { buildUrlOpenPageSelfAndRestBlank } from 'app/utilities/StringHelpers/StringHelpers';

export type OperationBoxItemProps = {href: string; title: string; image: BackgroundImageProps};

const OperationBoxItem = ({href, title, image}: OperationBoxItemProps) => (
  <div className='OperationBoxItem' onClick={()=>buildUrlOpenPageSelfAndRestBlank(href)}>
    <div className='OperationBoxItem__image' style={{ backgroundImage: `${image?.style?.backgroundImage}` }}/>
    <span className='OperationBoxItem__title'>{title}</span>
    <span className='OperationBoxItem__button'>&#187;</span>
  </div>
);

export default OperationBoxItem;
